'use client'

import type React from 'react'
import { useScrollMasks } from '@/hooks/useScrollMasks'
import { cn } from '@/lib/styles'
import styles from './Scrollable.module.css'

export function Scrollable({
	className,
	scrollableClassName,
	children,
}: {
	className?: string
	scrollableClassName?: string
	children?: React.ReactNode
}) {
	const { scrollableRef, masks } = useScrollMasks()

	return (
		<div className={cn(className, styles.scrollableWrapper)}>
			<div ref={scrollableRef} className={cn(scrollableClassName, styles.scrollable)}>
				{children}
			</div>
			<div className={cn(styles.scrollableMaskStart, masks.top && styles.visible)} />
			<div className={cn(styles.scrollableMaskEnd, masks.bottom && styles.visible)} />
		</div>
	)
}
